
import { createI18n } from 'vue-i18n';

const messages = {
  de: {
	view: {
		dashboard: 'Dashboard',
		dashboard_standort_filter: 'Standort',
		dashboard_function_filter: 'Funktion',
		dashboard_all_standorts: 'Alle Standorte',
		dashboard_all_functions: 'Alle Funktionen',
		dashboard_own_functions: 'Eigene Funktionen',
		rechtsgrundlagen: 'Rechtsgrundlagen',
		rechtsgrundlage: 'Rechtsgrundlage',
		rgkuerzel: 'Rechtsgrundlagen Kürzel',
		rechtsaspekt: 'Rechtsaspekt',
		pflichten: 'Pflichten',
		pflicht: 'Pflicht',
		tasks: 'Aufgaben',
		notification: 'Benachrichtigung',
		task: 'Aufgabe',
		logs: 'Historie',
		excel: 'Excel Export',
		customers: 'Kunden',
		customer: 'Kunde',
		iso_standards: 'ISO-Normen',
		iso_standard: 'ISO-Norm',
		inactive: 'inaktiv',
		users: 'Nutzer',
		user: 'Nutzer',
		roles: 'Rollen',
		rights: 'Rechte',
		standorts: 'Standorte',
		standort: 'Standort',
		functions: 'Funktionen',
		function: 'Funktion',
		imports: 'Importe',
		gefahrstoffe: 'Gefahrstoffe',
		gefahrstoff: 'Gefahrstoff',
		settings:  'Einstellungen', 
		entries: 'Einträge',
		entriesperpage: 'Einträge pro Seite',
	  prev: 'Zurück',
	  next: 'Weiter',
	  page: 'Seite',
		self: 'Eigene',
	  of: 'von',
		columns: 'Spalten',
		columns_hs: 'Spalten ein-/ausblenden',
		reset_filter: 'Filter zurücksetzen',
		cleared_filter: 'Filter leer',
		filter_placeholder: 'Filter...',
		actions: 'Aktionen',
		all: 'Alle',
		rechtsaspect: 'Rechtsaspect',
		draghandle: 'Spalte umziehen',
		resizehandle: 'Spaltenbreite ändern',
		btn_rechtsgrundlagen: 'Rechtsgrundlagen',
		btn_pflichten: 'Pflichten',
    btn_rg_standardtexts: 'Standard Texts',
		rg_standardtexts_empty: 'Keine Texte verfügbar.',
		btn_edit: 'Bearbeiten in Tabelle',
		btn_detail: 'Details und Bearbeiten',
		btn_delete: 'Löschen',
		btn_cancel: 'Abbrechen',
		btn_save: 'Speichern',
		btn_saving: 'Speichern…',
		unsaved_changes_title: 'Ungespeicherte Änderungen',
		unsaved_changes_description: 'Sie haben Änderungen vorgenommen, die noch nicht gespeichert wurden.',
		unsaved_changes_save: 'Änderungen speichern',
		unsaved_changes_discard: 'Änderungen verwerfen',
		unsaved_changes_continue: 'Weiter bearbeiten',
		loading: 'Daten werden geladen…',
		btn_rights: 'Rechte konfigurieren',
		btn_sendpasswd: 'Einrichtungslink senden',
		btn_impersonate_user: 'Als Nutzer anmelden',
		sel_choose_right: 'Rechtekategorie wählen...',
		btn_rg_pflichten: 'Pflichten für {rg}',
		btn_rg_normify_update: 'Rechtsgrundlage mit Normify aktualisieren: {rg}',
		rg_normify_update_title: 'Normify-Aktualisierung',
		rg_normify_update_description: 'Rechtsgrundlage mit Normify aktualisieren: {rg}',
		rg_normify_update_choice: 'Sollen bestehende Daten mit Normify ersetzt werden oder sollen nur fehlende Felder ergänzt werden?',
		rg_normify_update_fill_missing: 'Nur fehlende ergänzen',
		rg_normify_update_overwrite: 'Überschreiben',
		rg_normify_debug_title: 'Vergleich',
		rg_normify_debug_hmc: 'HMC-Intern',
		rg_normify_debug_mode: 'Modus',
		rg_normify_debug_changed: 'Geändert',
		rg_normify_debug_standardtexts: 'Standardtexte erstellt/aktualisiert/übersprungen/fehlgeschlagen',
		rg_normify_debug_pflichten: 'Pflichten erstellt/aktualisiert/übersprungen/fehlgeschlagen',
		rg_normify_debug_field: 'Feld',
		rg_normify_debug_old: 'Alt',
		rg_normify_debug_new: 'Neu',
		rg_normify_debug_empty: 'Keine Rechtsgrundlagen-Felder wurden geändert.',
		rg_normify_debug_show_json: 'API JSON',
		rg_normify_debug_hide_json: 'API JSON verbergen',
		rg_normify_debug_json_title: 'API Ergebnis',
		rg_ai_generate: 'AI-Felder generieren',
		rg_ai_regenerate: 'AI-Felder neu generieren',
		rg_ai_queued_title: 'AI-Generierung',
		rg_ai_queued: 'Die Generierung wurde zur Warteschlange hinzugefügt.',
		rg_ai_running: 'AI-Felder werden generiert',
		rg_ai_queue_failed: 'AI-Generierung konnte nicht gestartet werden.',
		rg_generation_requires_standardtexts: 'Zuerst müssen Standardtexte für diese österreichische Rechtsgrundlage synchronisiert werden.',
		rg_pflichten_generate: 'Pflichten für dieses Gesetz generieren',
		rg_pflichten_regenerate: 'Pflichten neu generieren',
		rg_pflichten_queued_title: 'Pflichten-Generierung',
		rg_pflichten_queued: 'Die Pflichten-Generierung wurde zur Warteschlange hinzugefügt.',
		rg_pflichten_running: 'Pflichten werden generiert',
		rg_pflichten_queue_failed: 'Pflichten-Generierung konnte nicht gestartet werden.',
		rg_pflichten_regeneration_title: 'Pflichten neu generieren',
		rg_pflichten_regeneration_description: 'Für {rg} bestehen bereits KI-generierte Pflichten.',
		rg_pflichten_regeneration_choice: 'Sollen nur fehlende oder ungültige Felder ergänzt oder alle KI-generierten Inhalte vollständig neu erzeugt werden?',
		rg_pflichten_regeneration_warning: 'Bei einer vollständigen Neugenerierung werden bestehende KI-Inhalte überschrieben und veraltete, nicht zugewiesene KI-Pflichten gelöscht. Manuell erstellte und Kunden zugewiesene Pflichten bleiben erhalten.',
		rg_pflichten_fill_missing: 'Nur fehlende Felder ergänzen',
		rg_pflichten_regenerate_all: 'Vollständig neu generieren',
		btn_excel: 'Excel generieren',
		btn_quenticexcel: 'Quentic Excel generieren',
		btn_quentic_token: 'Quentic API-Token verwalten',
		btn_logdetails: 'Log Details',
		btn_workflow: 'Daten aktualisieren',
		btn_workflow_clear: 'Feld Workflow zurücksetzen',
		btn_duplicate_customer: 'Muster GmbH duplizieren',
		btn_comments: 'Kommentare',
		btn_notification: 'Benachrichtigung öffnen',
		btn_notification_add: 'Benachrichtigung hinzufügen',
	  customer_assignment: 'Kundenzuweisung',
		function_assignment: 'Funktionszuweisung',
		user_assignment: 'Personenzuweisung',
		edit_notification: 'Benachrichtigung bearbeiten',
		logdetails: 'Details',
		comments: 'Kommentare',
    addcomment: 'Kommentar hinzufügen',
		add: 'hinzufügen',
		logout: 'Abmelden',
		assignment: 'Zuweisung',
		none: 'Keine',
		own: 'Eigene',
		copy: 'Kopieren',
    sendemail: 'Per E-Mail benachrichtigen',
		edit: 'Bearbeite',
		hide: 'Verstecke',
		collapse: 'Einklappen',
    close: 'Schließen',
    customer_duplicate_title: 'Muster GmbH duplizieren',
    customer_duplicate_description: 'Neuen Kundennamen eingeben.',
    customer_duplicate_name: 'Neuer Kundenname',
    customer_duplicate_submit: 'Duplizieren',
    customer_duplicate_started: 'Muster GmbH wird dupliziert...',
    customer_duplicate_done: 'Duplizierung abgeschlossen.',
    customer_duplicate_failed: 'Duplizierung fehlgeschlagen.',
    customer_duplicate_name_required: 'Bitte einen Kundennamen eingeben.',
    customer_duplicate_new_id: 'Neue Kunden-ID:',
    quentic_token_title: 'Quentic API-Token',
    quentic_token_create_description: 'Erzeugen Sie einen API-Token für diesen Kunden.',
    quentic_token_rotate_description: 'Dieser Kunde hat bereits einen API-Token. Ein neuer Token macht den bisherigen sofort ungültig.',
    quentic_token_create: 'Token erzeugen',
    quentic_token_rotate: 'Token erneuern',
    quentic_token_rotate_confirm: 'Der bisherige Quentic API-Token wird sofort ungültig. Fortfahren?',
    quentic_token_one_time: 'Neuer API-Token',
    quentic_token_store_warning: 'Dieser Token wird nur einmal angezeigt. Bitte jetzt sicher speichern.',
    quentic_token_copy: 'Token kopieren',
    quentic_token_copied: 'Quentic API-Token kopiert.',
    quentic_token_copy_failed: 'Quentic API-Token konnte nicht kopiert werden.',
    quentic_token_failed: 'Quentic API-Token konnte nicht erzeugt werden.',
    quentic_dashboard: 'Quentic Dashboard',
    quentic_dashboard_title: 'Quentic Dashboard',
    quentic_dashboard_subtitle: 'API-Zugriffe und Token-Aktivität · Zeitzone {zone}',
    quentic_dashboard_refresh: 'Aktualisieren',
    quentic_dashboard_load_failed: 'Das Quentic Dashboard konnte nicht geladen werden.',
    quentic_dashboard_success_24h: 'Erfolgreich · 24 Stunden',
    quentic_dashboard_success_7d: 'Erfolgreich · 7 Tage',
    quentic_dashboard_unauthorized_24h: 'Nicht autorisiert · 24 Stunden',
    quentic_dashboard_unauthorized_7d: 'Nicht autorisiert · 7 Tage',
    quentic_dashboard_tokens_due: 'Token zur Erneuerung',
    quentic_dashboard_last_success: 'Letzter erfolgreicher Zugriff',
    quentic_dashboard_customer_tokens: 'Kunden und API-Token',
    quentic_dashboard_customer: 'Kunde',
    quentic_dashboard_token_age: 'Token-Alter',
    quentic_dashboard_last_request: 'Letzter erfolgreicher Zugriff',
    quentic_dashboard_last_origin: 'Letzte Herkunft',
    quentic_dashboard_requests_90d: 'Zugriffe · 90 Tage',
    quentic_dashboard_ips_90d: 'IP-Adressen · 90 Tage',
    quentic_dashboard_unknown_age: 'Alter unbekannt',
    quentic_dashboard_days: '{count} Tage',
    quentic_dashboard_no_tokens: 'Keine aktiven Quentic API-Token vorhanden.',
    quentic_dashboard_recent_requests: 'Letzte API-Zugriffe',
    quentic_dashboard_all_customers: 'Alle Kunden',
    quentic_dashboard_all_statuses: 'Alle Status',
    quentic_dashboard_outcome_success: 'Erfolgreich',
    quentic_dashboard_outcome_unauthorized: 'Nicht autorisiert',
    quentic_dashboard_outcome_error: 'Fehler',
    quentic_dashboard_time: 'Zeit',
    quentic_dashboard_status: 'Status',
    quentic_dashboard_origin: 'IP und Client',
    quentic_dashboard_duration: 'Dauer',
    quentic_dashboard_size: 'Größe',
    quentic_dashboard_records: 'Normen / Pflichten',
    quentic_dashboard_unattributed: 'Nicht zugeordnet',
    quentic_dashboard_no_requests: 'Keine passenden API-Zugriffe gefunden.',
    quentic_dashboard_request_total: '{count} Zugriffe',
    quentic_dashboard_privacy_note: 'IP-Adressen und Client-Informationen werden nach 90 Tagen gelöscht.',
    login: 'Anmeldung',
    yes: 'Ja',
    no: 'Nein',
		user_set_inactive_confirm: 'Diesen Nutzer deaktivieren? Er kann sich nicht mehr anmelden und erscheint für Kunden nicht mehr in der Nutzerliste.',
		user_set_inactive_title: 'Nutzer deaktiviert',
		user_set_inactive_desc: 'Der Nutzer ist jetzt inaktiv.',
	},
    projects: {
      add: 'Add Project',
      delete: 'Delete Project'
    },
    processManagement: {
      title: 'Prozessmanagement', subtitle: 'Prozesse übersichtlich dokumentieren, verknüpfen und freigeben.',
      nav: { map: 'Prozesslandkarte', processes: 'Prozesse', media: 'Medien' },
      categories: { management: 'Führungsprozesse', core: 'Kernprozesse', support: 'Unterstützungsprozesse' },
      tabs: { details: 'Stammdaten', turtle: 'Turtle Chart', flow: 'Flussdiagramm', releases: 'Freigaben' },
      turtle: { inputs: 'Eingaben', outputs: 'Ergebnisse', responsibilities: 'Wer?', resources: 'Womit?', methods: 'Wie?', kpis: 'Kennzahlen' },
      nodeTypes: { start: 'Start', end: 'Ende', activity: 'Aktivität', decision: 'Entscheidung', document: 'Dokument', process: 'Prozess' },
      searchProcesses: 'Prozesse suchen…', draft: 'Entwurf', released: 'Freigegeben', emptyCategory: 'Keine Prozesse in dieser Kategorie.',
      back: 'Zurück', code: 'Prozesscode', processTitle: 'Prozesstitel', category: 'Kategorie', owner: 'Prozessverantwortlicher',
      objective: 'Ziel', scope: 'Geltungsbereich', function: 'Verantwortliche Funktion', position: 'Reihenfolge',
      relatedProcesses: 'Verknüpfte Prozesse', documents: 'Dokumente', save: 'Speichern', saved: 'Gespeichert',
      saveFailed: 'Speichern fehlgeschlagen', archive: 'Archivieren', archiveConfirm: 'Diesen Prozess archivieren?',
      unreleasedChanges: 'Nicht freigegebene Änderungen', onePerLine: 'Ein Eintrag pro Zeile', releaseNote: 'Freigabe-/Änderungsnotiz',
      release: 'Freigeben', releaseComplete: 'Prozess freigegeben', releaseFailed: 'Freigabe fehlgeschlagen', noReleases: 'Noch keine Freigaben.',
      media: 'Medien', mediaDescription: 'Versionierte Dokumente verwalten und mit Prozessen verknüpfen.', upload: 'Hochladen',
      documentCategory: 'Dokumentkategorie', description: 'Beschreibung', visibility: 'Sichtbarkeit', moduleWide: 'Alle Modulnutzer', sharingUsers: 'Benutzer', sharingFunctions: 'Funktionen',
      restricted: 'Eingeschränkt', file: 'Datei', uploadFailed: 'Upload fehlgeschlagen', noFile: 'Keine Datei', noDocuments: 'Keine Dokumente vorhanden.',
      revisions: 'Revisionen', newRevision: 'Neue Revision', changeNote: 'Änderungsnotiz', sharing: 'Freigaben', links: 'Verknüpfungen',
      create: 'Erstellen', loading: 'Prozessmanagement wird geladen…',
      loadFailed: 'Prozessmanagement konnte nicht geladen werden', newProcess: 'Neuer Prozess', noProcesses: 'Noch keine Prozesse vorhanden.',
      saving: 'Speichern…', autosaved: 'Automatisch gespeichert', label: 'Bezeichnung', documentTitle: 'Dokumenttitel',
      flowConnectionHint: 'Verbindung erstellen: Von einem beliebigen grünen Punkt an einem Element zu einem grünen Punkt an einem anderen Element ziehen.',
      flowConnectionPoint: 'Verbindung hier beginnen oder ablegen',
      flowConnectionSource: 'Verbindung hier beginnen', flowConnectionTarget: 'Verbindung hier ablegen',
      archiveDocumentConfirm: 'Dieses Dokument archivieren?', linkedProcess: 'Verknüpfter Prozess', searchDocuments: 'Dokumente durchsuchen…',
      addEntry: 'Eintrag hinzufügen', entryText: 'Eintrag beschreiben', linkProcesses: 'Prozesse verknüpfen', removeEntry: 'Eintrag entfernen',
      unavailableProcess: 'Prozess nicht verfügbar', noLinkTargets: 'Keine passenden Prozesse.', noTurtleEntries: 'Noch keine Einträge.',
      linkedProcessesTitle: 'Verknüpfte Prozesse', pinnedVersion: 'Fixierte Version', selectLinkedProcess: 'Wählen Sie einen verknüpften Prozess aus.',
      linkedProcessLoadFailed: 'Der verknüpfte Prozess konnte nicht geladen werden.', diagramPreview: 'Diagrammvorschau',
      noDiagramPreview: 'Für diesen Prozess ist kein Turtle Chart oder Flussdiagramm vorhanden.', openFullProcess: 'Vollständigen Prozess öffnen',
      searchProjects: 'Projekte durchsuchen…', newProject: 'Neues Projekt', projectName: 'Projektname', projectDescription: 'Projektbeschreibung',
      noProjectDescription: 'Keine Beschreibung', noProjects: 'Noch keine Projekte vorhanden.', backToProjects: 'Zurück zu den Projekten',
      archiveProjectConfirm: 'Dieses Projekt mit seinem gesamten Arbeitsbereich archivieren?', processesCount: 'Prozesse', documentsCount: 'Dokumente'
    }
  },
  en: {
    view: {
      dashboard: 'Dashboard',
      dashboard_standort_filter: 'Location',
      dashboard_function_filter: 'Function',
      dashboard_all_standorts: 'All locations',
      dashboard_all_functions: 'All functions',
      dashboard_own_functions: 'Own functions',
      rechtsgrundlagen: 'Laws',
      rechtsgrundlage: 'Law',
      rgkuerzel: 'Law Abbreviation',
      rechtsaspekt: 'Legal Aspect',
      pflichten: 'Duties',
      pflicht: 'Duty',
      tasks: 'Tasks',
      notification: 'Notification',
      task: 'Task',
      logs: 'History',
      excel: 'Excel Export',
      customers: 'Customers',
      customer: 'Customer',
      iso_standards: 'ISO standards',
      iso_standard: 'ISO standard',
      inactive: 'inactive',
      users: 'Users',
      user: 'User',
      roles: 'Roles',
      rights: 'Rights',
      standorts: 'Locations',
      standort: 'Location',
      functions: 'Functions',
      function: 'Function',
      imports: 'Imports',
      gefahrstoffe: 'Hazardous Substances',
      gefahrstoff: 'Hazardous Substance',
      settings: 'Settings',
      entries: 'Entries',
      entriesperpage: 'Entries per page',
      prev: 'Previous',
      next: 'Next',
      page: 'Page',
      self: 'Own',
      of: 'of',
      columns: 'Columns',
      columns_hs: 'Show/hide columns',
      reset_filter: 'Reset filter',
      cleared_filter: 'Filter cleared',
      filter_placeholder: 'Filter...',
      actions: 'Actions',
      all: 'All',
      rechtsaspect: 'Legal Aspect',
      draghandle: 'Drag column',
      resizehandle: 'Change column width',
      btn_rechtsgrundlagen: 'Laws',
      btn_pflichten: 'Duties',
      rg_standardtexts_empty: 'No texts available.',
      btn_edit: 'Edit in table',
      btn_detail: 'Details and Edit',
      btn_delete: 'Delete',
      btn_cancel: 'Reset',
      btn_save: 'Save',
      btn_saving: 'Saving…',
      unsaved_changes_title: 'Unsaved changes',
      unsaved_changes_description: 'You have made changes that have not been saved yet.',
      unsaved_changes_save: 'Save changes',
      unsaved_changes_discard: 'Discard changes',
      unsaved_changes_continue: 'Continue editing',
      loading: 'Loading Data…',
      btn_rights: 'Configure rights',
      btn_sendpasswd: 'Send setup link',
      btn_impersonate_user: 'Log in as user',
      sel_choose_right: 'Choose right category...',
      btn_rg_pflichten: 'Duties for {rg}',
      btn_rg_normify_update: 'Update law from Normify: {rg}',
      rg_normify_update_title: 'Normify update',
      rg_normify_update_description: 'Update law from Normify: {rg}',
      rg_normify_update_choice: 'Should existing data be replaced with Normify data, or should only missing fields be filled?',
      rg_normify_update_fill_missing: 'Fill missing only',
      rg_normify_update_overwrite: 'Overwrite',
      rg_normify_debug_title: 'Comparison',
      rg_normify_debug_hmc: 'HMC internal',
      rg_normify_debug_mode: 'Mode',
      rg_normify_debug_changed: 'Changed',
      rg_normify_debug_standardtexts: 'Standard texts created/updated/skipped/failed',
      rg_normify_debug_pflichten: 'Duties created/updated/skipped/failed',
      rg_normify_debug_field: 'Field',
      rg_normify_debug_old: 'Old',
      rg_normify_debug_new: 'New',
      rg_normify_debug_empty: 'No law fields were changed.',
      rg_normify_debug_show_json: 'API JSON',
      rg_normify_debug_hide_json: 'Hide API JSON',
      rg_normify_debug_json_title: 'API result',
      rg_ai_generate: 'Generate AI fields',
      rg_ai_regenerate: 'Regenerate AI fields',
      rg_ai_queued_title: 'AI generation',
      rg_ai_queued: 'Generation was added to the queue.',
      rg_ai_running: 'AI fields are being generated',
      rg_ai_queue_failed: 'AI generation could not be started.',
      rg_generation_requires_standardtexts: 'Standard texts must first be synchronized for this Austrian law.',
      rg_pflichten_generate: 'Generate duties for this law',
      rg_pflichten_regenerate: 'Regenerate duties',
      rg_pflichten_queued_title: 'Duties generation',
      rg_pflichten_queued: 'Duties generation was added to the queue.',
      rg_pflichten_running: 'Duties are being generated',
      rg_pflichten_queue_failed: 'Duties generation could not be started.',
      btn_excel: 'Generate Excel',
      btn_quenticexcel: 'Generate Quentic Excel',
      btn_quentic_token: 'Manage Quentic API token',
      btn_logdetails: 'Log Details',
      btn_workflow: 'Update data',
      btn_workflow_clear: 'Reset workflow field',
      btn_duplicate_customer: 'Duplicate Muster GmbH',
      btn_comments: 'Comments',
      btn_notification: 'Open notification',
      btn_notification_add: 'Add notification',
      customer_assignment: 'Customer assignment',
      function_assignment: 'Function assignment',
      user_assignment: 'Person assignment',
      edit_notification: 'Edit notification',
      logdetails: 'Details',
      comments: 'Comments',
      addcomment: 'Add comment',
      add: 'add',
      logout: 'Logout',
      assignment: 'Assignment',
      none: 'none',
      own: 'Own',
      copy: 'Copy',
      sendemail: 'Notify',
      edit: 'Edit',
      hide: 'Hide',
      collapse: 'Collapse',
      close: 'Close',
      customer_duplicate_title: 'Duplicate Muster GmbH',
      customer_duplicate_description: 'Enter the new customer name.',
      customer_duplicate_name: 'New customer name',
      customer_duplicate_submit: 'Duplicate',
      customer_duplicate_started: 'Duplicating Muster GmbH...',
      customer_duplicate_done: 'Duplication complete.',
      customer_duplicate_failed: 'Duplication failed.',
      customer_duplicate_name_required: 'Please enter a customer name.',
      customer_duplicate_new_id: 'New customer ID:',
      quentic_token_title: 'Quentic API token',
      quentic_token_create_description: 'Generate an API token for this customer.',
      quentic_token_rotate_description: 'This customer already has an API token. Generating a new token immediately invalidates the old one.',
      quentic_token_create: 'Generate token',
      quentic_token_rotate: 'Rotate token',
      quentic_token_rotate_confirm: 'The current Quentic API token will be invalidated immediately. Continue?',
      quentic_token_one_time: 'New API token',
      quentic_token_store_warning: 'This token is shown only once. Store it securely now.',
      quentic_token_copy: 'Copy token',
      quentic_token_copied: 'Quentic API token copied.',
      quentic_token_copy_failed: 'Could not copy the Quentic API token.',
      quentic_token_failed: 'Could not generate the Quentic API token.',
      quentic_dashboard: 'Quentic Dashboard',
      quentic_dashboard_title: 'Quentic Dashboard',
      quentic_dashboard_subtitle: 'API access and token activity · Time zone {zone}',
      quentic_dashboard_refresh: 'Refresh',
      quentic_dashboard_load_failed: 'Could not load the Quentic dashboard.',
      quentic_dashboard_success_24h: 'Successful · 24 hours',
      quentic_dashboard_success_7d: 'Successful · 7 days',
      quentic_dashboard_unauthorized_24h: 'Unauthorized · 24 hours',
      quentic_dashboard_unauthorized_7d: 'Unauthorized · 7 days',
      quentic_dashboard_tokens_due: 'Tokens due for rotation',
      quentic_dashboard_last_success: 'Last successful request',
      quentic_dashboard_customer_tokens: 'Customers and API tokens',
      quentic_dashboard_customer: 'Customer',
      quentic_dashboard_token_age: 'Token age',
      quentic_dashboard_last_request: 'Last successful request',
      quentic_dashboard_last_origin: 'Last origin',
      quentic_dashboard_requests_90d: 'Requests · 90 days',
      quentic_dashboard_ips_90d: 'IP addresses · 90 days',
      quentic_dashboard_unknown_age: 'Age unknown',
      quentic_dashboard_days: '{count} days',
      quentic_dashboard_no_tokens: 'No active Quentic API tokens.',
      quentic_dashboard_recent_requests: 'Recent API requests',
      quentic_dashboard_all_customers: 'All customers',
      quentic_dashboard_all_statuses: 'All statuses',
      quentic_dashboard_outcome_success: 'Successful',
      quentic_dashboard_outcome_unauthorized: 'Unauthorized',
      quentic_dashboard_outcome_error: 'Error',
      quentic_dashboard_time: 'Time',
      quentic_dashboard_status: 'Status',
      quentic_dashboard_origin: 'IP and client',
      quentic_dashboard_duration: 'Duration',
      quentic_dashboard_size: 'Size',
      quentic_dashboard_records: 'Laws / duties',
      quentic_dashboard_unattributed: 'Unattributed',
      quentic_dashboard_no_requests: 'No matching API requests found.',
      quentic_dashboard_request_total: '{count} requests',
      quentic_dashboard_privacy_note: 'IP addresses and client information are deleted after 90 days.',
      yes: 'Yes',
      no: 'No',
      user_set_inactive_confirm: 'Deactivate this user? They will not be able to sign in and will be hidden from the customer user list.',
      user_set_inactive_title: 'User deactivated',
      user_set_inactive_desc: 'The user is now inactive.',
    },
    projects: {
      add: 'Add Project',
      delete: 'Delete Project'
    },
    processManagement: {
      title: 'Process Management', subtitle: 'Document, connect, and release processes in one clean workspace.',
      nav: { map: 'Process Map', processes: 'Processes', media: 'Media' },
      categories: { management: 'Management Processes', core: 'Core Processes', support: 'Support Processes' },
      tabs: { details: 'Master Data', turtle: 'Turtle Chart', flow: 'Flowchart', releases: 'Releases' },
      turtle: { inputs: 'Inputs', outputs: 'Outputs', responsibilities: 'Who?', resources: 'With what?', methods: 'How?', kpis: 'KPIs' },
      nodeTypes: { start: 'Start', end: 'End', activity: 'Activity', decision: 'Decision', document: 'Document', process: 'Process' },
      searchProcesses: 'Search processes…', draft: 'Draft', released: 'Released', emptyCategory: 'No processes in this category.',
      back: 'Back', code: 'Process code', processTitle: 'Process title', category: 'Category', owner: 'Process owner',
      objective: 'Objective', scope: 'Scope', function: 'Responsible function', position: 'Position', relatedProcesses: 'Linked processes',
      documents: 'Documents', save: 'Save', saved: 'Saved', saveFailed: 'Save failed', archive: 'Archive', archiveConfirm: 'Archive this process?',
      unreleasedChanges: 'Unreleased changes', onePerLine: 'One entry per line', releaseNote: 'Release/change note', release: 'Release',
      releaseComplete: 'Process released', releaseFailed: 'Release failed', noReleases: 'No releases yet.', media: 'Media',
      mediaDescription: 'Manage versioned documents and link them to processes.', upload: 'Upload', documentCategory: 'Document category',
      description: 'Description', visibility: 'Visibility', moduleWide: 'All module users', restricted: 'Restricted', sharingUsers: 'Users', sharingFunctions: 'Functions', file: 'File',
      uploadFailed: 'Upload failed', noFile: 'No file', noDocuments: 'No documents available.', revisions: 'Revisions', newRevision: 'New revision',
      changeNote: 'Change note', sharing: 'Sharing', links: 'Links', create: 'Create', loading: 'Loading Process Management…',
      loadFailed: 'Process Management could not be loaded', newProcess: 'New process', noProcesses: 'No processes yet.',
      saving: 'Saving…', autosaved: 'Saved automatically', label: 'Label', documentTitle: 'Document title',
      flowConnectionHint: 'Create a connection: Drag from any green point on one element to any green point on another element.',
      flowConnectionPoint: 'Start or drop a connection here',
      flowConnectionSource: 'Start connection here', flowConnectionTarget: 'Drop connection here',
      archiveDocumentConfirm: 'Archive this document?', linkedProcess: 'Linked process', searchDocuments: 'Search documents…',
      addEntry: 'Add entry', entryText: 'Describe entry', linkProcesses: 'Link processes', removeEntry: 'Remove entry',
      unavailableProcess: 'Process unavailable', noLinkTargets: 'No matching processes.', noTurtleEntries: 'No entries yet.',
      linkedProcessesTitle: 'Linked processes', pinnedVersion: 'Pinned version', selectLinkedProcess: 'Select a linked process.',
      linkedProcessLoadFailed: 'The linked process could not be loaded.', diagramPreview: 'Diagram preview',
      noDiagramPreview: 'This process has no Turtle Chart or flowchart to preview.', openFullProcess: 'Open full process',
      searchProjects: 'Search projects…', newProject: 'New project', projectName: 'Project name', projectDescription: 'Project description',
      noProjectDescription: 'No description', noProjects: 'No projects yet.', backToProjects: 'Back to projects',
      archiveProjectConfirm: 'Archive this project and its entire workspace?', processesCount: 'processes', documentsCount: 'documents'
    }
  },
  'zh-TW': {
    view: {
      dashboard: '仪表板',
      dashboard_standort_filter: '位置',
      dashboard_function_filter: '功能',
      dashboard_all_standorts: '所有位置',
      dashboard_all_functions: '所有功能',
      dashboard_own_functions: '我的功能',
      rechtsgrundlagen: '法律',
      rechtsgrundlage: '法律',
      rgkuerzel: '法律缩写',
      rechtsaspekt: '法律方面',
      pflichten: '义务',
      pflicht: '义务',
      tasks: '任务',
      notification: '通知',
      task: '任务',
      logs: '历史',
      excel: 'Excel Export',
      customers: '客户',
      customer: '客户',
      iso_standards: 'ISO 標準',
      iso_standard: 'ISO 標準',
      inactive: '未啟用',
      users: '用户',
      user: '用户',
      roles: '角色',
      rights: '权限',
      standorts: '位置',
      standort: '位置',
      functions: '功能',
      function: '功能',
      imports: '导入',
      gefahrstoffe: '危险物质',
      gefahrstoff: '危险物质',
      settings: '设置',
      entries: '条目',
      entriesperpage: '每页条目数',
      prev: '上一页',
      next: '下一页',
      page: '页',
      self: '自己的',
      of: '的',
      columns: '列',
      columns_hs: '显示/隐藏列',
      reset_filter: '重置筛选器',
      cleared_filter: '筛选器已清除',
      filter_placeholder: '筛选...',
      actions: '操作',
      all: '全部',
      rechtsaspect: '法律方面',
      draghandle: '拖动列',
      resizehandle: '更改列宽',
      btn_rechtsgrundlagen: '法律',
      btn_pflichten: '义务',
      rg_standardtexts_empty: '沒有可用的文字。',
      btn_edit: '在表格中编辑',
      btn_detail: '详情和编辑',
      btn_delete: '删除',
      btn_cancel: '重置',
      btn_save: '保存',
      btn_saving: '保存中…',
      unsaved_changes_title: '未保存的更改',
      unsaved_changes_description: '您所做的更改尚未保存。',
      unsaved_changes_save: '保存更改',
      unsaved_changes_discard: '放弃更改',
      unsaved_changes_continue: '继续编辑',
      loading: '加载中…',
      btn_rights: '配置权限',
      btn_sendpasswd: '发送设置链接',
      btn_impersonate_user: '以用户身份登录',
      sel_choose_right: '选择权限类别...',
      btn_rg_pflichten: '{rg}的义务',
      btn_rg_normify_update: '从 Normify 更新法律：{rg}',
      rg_normify_update_title: 'Normify 更新',
      rg_normify_update_description: '从 Normify 更新法律：{rg}',
      rg_normify_update_choice: '要用 Normify 数据替换现有数据，还是只填写缺失字段？',
      rg_normify_update_fill_missing: '仅填写缺失项',
      rg_normify_update_overwrite: '覆盖',
      rg_normify_debug_title: '对比',
      rg_normify_debug_hmc: 'HMC 内部编号',
      rg_normify_debug_mode: '模式',
      rg_normify_debug_changed: '已更改',
      rg_normify_debug_standardtexts: '标准文本 创建/更新/跳过/失败',
      rg_normify_debug_pflichten: '义务 创建/更新/跳过/失败',
      rg_normify_debug_field: '字段',
      rg_normify_debug_old: '旧值',
      rg_normify_debug_new: '新值',
      rg_normify_debug_empty: '没有法律字段被更改。',
      rg_normify_debug_show_json: 'API JSON',
      rg_normify_debug_hide_json: '隐藏 API JSON',
      rg_normify_debug_json_title: 'API 结果',
      rg_ai_generate: '生成 AI 字段',
      rg_ai_regenerate: '重新生成 AI 字段',
      rg_ai_queued_title: 'AI 生成',
      rg_ai_queued: '生成任务已加入队列。',
      rg_ai_running: '正在生成 AI 字段',
      rg_ai_queue_failed: '无法启动 AI 生成。',
      rg_generation_requires_standardtexts: '必须先同步此奥地利法律的标准文本。',
      rg_pflichten_generate: '为此法律生成义务',
      rg_pflichten_regenerate: '重新生成义务',
      rg_pflichten_queued_title: '义务生成',
      rg_pflichten_queued: '义务生成任务已加入队列。',
      rg_pflichten_running: '正在生成义务',
      rg_pflichten_queue_failed: '无法启动义务生成。',
      btn_excel: '生成Excel',
      btn_quenticexcel: '生成Quentic Excel',
      btn_quentic_token: '管理 Quentic API 令牌',
      btn_logdetails: '日志详情',
      btn_workflow: '更新数据',
      btn_workflow_clear: '重置工作流字段',
      btn_duplicate_customer: '复制 Muster GmbH',
      btn_comments: '评论',
      btn_notification: '打开通知',
      btn_notification_add: '添加通知',
      customer_assignment: '客户分配',
      function_assignment: '功能分配',
      user_assignment: '人员分配',
      edit_notification: '编辑通知',
      logdetails: '详情',
      comments: '评论',
      addcomment: '添加评论',
      add: '添加',
      logout: '登出',
      assignment: '分配',
      none: '无',
      own: '自己的',
      copy: '复制',
      sendemail: '通知',
      edit: '编辑',
      hide: '隐藏',
      collapse: '折叠',
      close: '关闭',
      customer_duplicate_title: '复制 Muster GmbH',
      customer_duplicate_description: '输入新的客户名称。',
      customer_duplicate_name: '新客户名称',
      customer_duplicate_submit: '复制',
      customer_duplicate_started: '正在复制 Muster GmbH...',
      customer_duplicate_done: '复制完成。',
      customer_duplicate_failed: '复制失败。',
      customer_duplicate_name_required: '请输入客户名称。',
      customer_duplicate_new_id: '新客户 ID:',
      quentic_token_title: 'Quentic API 令牌',
      quentic_token_create_description: '为此客户生成 API 令牌。',
      quentic_token_rotate_description: '此客户已有 API 令牌。生成新令牌后，旧令牌将立即失效。',
      quentic_token_create: '生成令牌',
      quentic_token_rotate: '更新令牌',
      quentic_token_rotate_confirm: '当前 Quentic API 令牌将立即失效。是否继续？',
      quentic_token_one_time: '新 API 令牌',
      quentic_token_store_warning: '此令牌仅显示一次。请立即安全保存。',
      quentic_token_copy: '复制令牌',
      quentic_token_copied: '已复制 Quentic API 令牌。',
      quentic_token_copy_failed: '无法复制 Quentic API 令牌。',
      quentic_token_failed: '无法生成 Quentic API 令牌。',
      quentic_dashboard: 'Quentic 仪表板',
      quentic_dashboard_title: 'Quentic 仪表板',
      quentic_dashboard_subtitle: 'API 访问和令牌活动 · 时区 {zone}',
      quentic_dashboard_refresh: '刷新',
      quentic_dashboard_load_failed: '无法加载 Quentic 仪表板。',
      quentic_dashboard_success_24h: '成功 · 24 小时',
      quentic_dashboard_success_7d: '成功 · 7 天',
      quentic_dashboard_unauthorized_24h: '未授权 · 24 小时',
      quentic_dashboard_unauthorized_7d: '未授权 · 7 天',
      quentic_dashboard_tokens_due: '需要更新的令牌',
      quentic_dashboard_last_success: '最后成功访问',
      quentic_dashboard_customer_tokens: '客户和 API 令牌',
      quentic_dashboard_customer: '客户',
      quentic_dashboard_token_age: '令牌年龄',
      quentic_dashboard_last_request: '最后成功访问',
      quentic_dashboard_last_origin: '最后来源',
      quentic_dashboard_requests_90d: '访问 · 90 天',
      quentic_dashboard_ips_90d: 'IP 地址 · 90 天',
      quentic_dashboard_unknown_age: '年龄未知',
      quentic_dashboard_days: '{count} 天',
      quentic_dashboard_no_tokens: '没有有效的 Quentic API 令牌。',
      quentic_dashboard_recent_requests: '最近的 API 访问',
      quentic_dashboard_all_customers: '所有客户',
      quentic_dashboard_all_statuses: '所有状态',
      quentic_dashboard_outcome_success: '成功',
      quentic_dashboard_outcome_unauthorized: '未授权',
      quentic_dashboard_outcome_error: '错误',
      quentic_dashboard_time: '时间',
      quentic_dashboard_status: '状态',
      quentic_dashboard_origin: 'IP 和客户端',
      quentic_dashboard_duration: '耗时',
      quentic_dashboard_size: '大小',
      quentic_dashboard_records: '法规 / 义务',
      quentic_dashboard_unattributed: '未归属',
      quentic_dashboard_no_requests: '没有匹配的 API 访问。',
      quentic_dashboard_request_total: '{count} 次访问',
      quentic_dashboard_privacy_note: 'IP 地址和客户端信息将在 90 天后删除。',
      yes: '是',
      no: '否',
      user_set_inactive_confirm: '要停用此用户吗？他们将无法登录，且不会出现在客户的用户列表中。',
      user_set_inactive_title: '用户已停用',
      user_set_inactive_desc: '该用户现已停用。',
    },
    projects: {
      add: '添加项目',
      delete: '删除项目'
    },
    processManagement: {
      title: '流程管理', subtitle: '以清晰的方式記錄、連結及發布流程。',
      nav: { map: '流程地圖', processes: '流程', media: '媒體' },
      categories: { management: '管理流程', core: '核心流程', support: '支援流程' },
      tabs: { details: '基本資料', turtle: '烏龜圖', flow: '流程圖', releases: '發布版本' },
      turtle: { inputs: '輸入', outputs: '輸出', responsibilities: '由誰？', resources: '使用什麼？', methods: '如何進行？', kpis: '績效指標' },
      nodeTypes: { start: '開始', end: '結束', activity: '活動', decision: '決策', document: '文件', process: '流程' },
      searchProcesses: '搜尋流程…', draft: '草稿', released: '已發布', emptyCategory: '此類別沒有流程。',
      back: '返回', code: '流程代碼', processTitle: '流程標題', category: '類別', owner: '流程負責人', objective: '目標', scope: '適用範圍',
      function: '負責職能', position: '順序', relatedProcesses: '連結流程', documents: '文件', save: '儲存', saved: '已儲存',
      saveFailed: '儲存失敗', archive: '封存', archiveConfirm: '要封存此流程嗎？', unreleasedChanges: '尚未發布的變更',
      onePerLine: '每行一個項目', releaseNote: '發布／變更說明', release: '發布', releaseComplete: '流程已發布', releaseFailed: '發布失敗',
      noReleases: '尚無發布版本。', media: '媒體', mediaDescription: '管理版本化文件並連結至流程。', upload: '上傳',
      documentCategory: '文件類別', description: '說明', visibility: '可見範圍', moduleWide: '所有模組使用者', restricted: '受限', sharingUsers: '使用者', sharingFunctions: '職能',
      file: '檔案', uploadFailed: '上傳失敗', noFile: '沒有檔案', noDocuments: '尚無文件。', revisions: '修訂版本',
      newRevision: '新增修訂', changeNote: '變更說明', sharing: '分享', links: '連結', create: '建立',
      loading: '正在載入流程管理…', loadFailed: '無法載入流程管理',
      newProcess: '新增流程', noProcesses: '尚無流程。', saving: '儲存中…', autosaved: '已自動儲存', label: '名稱',
      flowConnectionHint: '建立連線：從一個元素的任意綠色連接點拖曳到另一個元素的任意綠色連接點。',
      flowConnectionPoint: '從這裡開始或完成連線',
      flowConnectionSource: '從這裡開始連線', flowConnectionTarget: '在這裡完成連線',
      documentTitle: '文件標題', archiveDocumentConfirm: '要封存此文件嗎？', linkedProcess: '連結流程', searchDocuments: '搜尋文件…',
      addEntry: '新增項目', entryText: '描述項目', linkProcesses: '連結流程', removeEntry: '移除項目',
      unavailableProcess: '流程無法使用', noLinkTargets: '沒有符合的流程。', noTurtleEntries: '尚無項目。',
      linkedProcessesTitle: '連結流程', pinnedVersion: '固定版本', selectLinkedProcess: '請選擇連結流程。',
      linkedProcessLoadFailed: '無法載入連結流程。', diagramPreview: '圖表預覽',
      noDiagramPreview: '此流程沒有可預覽的烏龜圖或流程圖。', openFullProcess: '開啟完整流程',
      searchProjects: '搜尋專案…', newProject: '新增專案', projectName: '專案名稱', projectDescription: '專案說明',
      noProjectDescription: '沒有說明', noProjects: '尚無專案。', backToProjects: '返回專案',
      archiveProjectConfirm: '要封存此專案及其完整工作區嗎？', processesCount: '個流程', documentsCount: '份文件'
    }
  },
};

// Get saved locale from localStorage, default to 'de'
const getInitialLocale = () => {
  if (typeof window !== 'undefined') {
    const savedLocale = localStorage.getItem('app_locale')
    if (savedLocale && (savedLocale === 'de' || savedLocale === 'en' || savedLocale === 'zh-TW')) {
      return savedLocale
    }
  }
  return 'de'
}

const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages
});

export default i18n;
